module.exports = __webpack_public_path__ + "img/logo.4bf29f35.svg";